<template>
  <WorkBenchSequenceWaggon
    height="calc(100% - 350px - 48px)"
    >
    <template #activator>
      <Activator
        key="nowaggonsactivtor"
        class="self-centered cursor-s-resize"
        @click.native="
          $router.push({
            name: `${location}SequenceEditor`
          })
          "
      />
    </template>
    <template #tabs>
      <draggable
        class="display-flex"
        :style="$route.matched[3].name === 'WorkBenchSequenceWaggonWorkPackageAdd'?
          `width: calc(${waggon[`${prefix}sworkpackages`].length} * 100px)`:'width: 100%'"
        animation="300"
        forceFallback="true"
        fallbackOnBody="true"
        :value="waggon[`${prefix}sworkpackages`]"
        :disabled="read_only"
        @input="
          create?
          updateWBLObject({
            path: [
            {sequence: ''},
            {swaggons: waggon_id},
            {sworkpackages: ''}
            ],
            update: $event,
            })
          :
          ''
        "
        @end="
        create?
        $router.push({
          name: `${location}SequenceWaggonWorkPackage`,
          params: {work_package_id: $event.newIndex}
          })
        :
        changeWBObjectPosition({
          url: [
            {[`${prefix}sequences`]: sequence_id},
            {[`${prefix}swaggons`]: waggon_id},
            {[`${prefix}sworkpackages`]: waggon[`${prefix}sworkpackages`][$event.oldIndex]},
            {pushpositions: ''}
          ],
          target: {
            target_id: waggon[`${prefix}sworkpackages`][$event.newIndex],
          }
          })"
        >
        <WorkBenchSequenceWaggonTab
          :class="`${read_only?'cursor-pointer':'cursor-grab mr-1'}`"
          v-for="(workpackage, index) in create?waggon[`${prefix}sworkpackages`]:getWBObjects({type: `${prefix}sworkpackages`, ids: waggon[`${prefix}sworkpackages`]})"
          :key="create?index:workpackage.id"
          :color="workpackage.color"
          :text_color="workpackage.textcolor"
          :token="workpackage.token"
          :icon="workpackage.icon"
          :selected="create?(index === $route.params.workpackage_id):(workpackage.id === $route.params.workpackage_id)"
          :width="create?((index === $route.params.workpackage_id)? `calc(100% - ${waggon[`${prefix}sworkpackages`].length-2} * 100px)`:'100px'):((workpackage.id === $route.params.workpackage_id)?`calc(100% - ${waggon[`${prefix}sworkpackages`].length-2} * 100px)`:'100px')"
          @click.native="routeToWaggonWorkPackage(index, workpackage)"
          >
          <template #content>
            <div>{{workpackage.token}} {{(create?index:workpackage.id) === $route.params.workpackage_id?`- ${workpackage.name}`:''}}</div>
          </template>
          <template
            #actions
            v-if="(create?index:workpackage.id) === $route.params.workpackage_id"
            >
            <StandardDeleteButton
              v-if="!read_only"
              :zoom="1"
              @clickDelete="
                create?
              ($router.push({
                    name: waggon[`${prefix}sworkpackages`].length > 1?
                      `${location}SequenceWaggonWorkPackage`:
                      `${location}SequenceWaggonWorkPackageAdd`,
                    params: waggon[`${prefix}sworkpackages`].length > 1?
                    {
                      work_package_id: index === 0?0:index-1
                    }:{}
                  }),
                deleteWBLObject({
                  path: [
                    {sequence: ''},
                    {swaggons: waggon_id},
                    {sworkpackages: ''}
                  ],
                  index: index
                }))
                :
                ($router.push({
                    name: waggon[`${prefix}sworkpackages`].length > 1?
                      `${location}SequenceWaggonWorkPackage`:
                      `${location}SequenceWaggonWorkPackageAdd`,
                    params: waggon[`${prefix}sworkpackages`].length > 1?
                    {
                      work_package_id: index === 0?
                        waggon[`${prefix}sworkpackages`][1]:
                        waggon[`${prefix}sworkpackages`][index-1]
                    }:{}
                  }),
                deleteWBObject({
                  url: [
                    {[`${prefix}sequences`]: sequence_id},
                    {[`${prefix}swaggons`]: waggon_id},
                    {[`${prefix}sworkpackages`]: workpackage.id}
                  ]
                }))
              "
              />
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="!read_only"
                  icon
                  small
                  :color="workpackage.textcolor"
                  v-on="on"
                  v-bind="attrs"
                  @click="$router.push({
                      name: `${location}SequenceWaggonWorkPackageEditor`,
                      params: {
                        editor_work_package_id: create?index:workpackage.id
                      }
                    })"
                  >
                  <v-icon small>edit</v-icon>
                </v-btn>
                </template>
                <span>{{$t('WorkBench.Editor.Sequence.Workpackage.edit')}}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  :color="workpackage.textcolor"
                  v-on="on"
                  v-bind="attrs"
                  @click.stop="
                  getNestedWorkPackageCreate(workpackage, true).then(work_package => {
                    updateWBLObject({
                      path: [
                      {workpackage: ''}
                      ],
                      update: work_package
                      }),
                      $router.push({
                       name: `WorkBenchSequenceWaggonWorkPackageAddWorkPackageEditor`,
                       params: {
                         workpackage_id: 'create',
                       }
                     })
                    })
                  "
                  >
                  <v-icon small>content_copy</v-icon>
                </v-btn>
                </template>
                <span>{{$t('WorkBench.Editor.Sequence.Workpackage.copy')}}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  :color="workpackage.textcolor"
                  v-on="on"
                  v-bind="attrs"
                  @click.stop="
                  getNestedWorkPackageCreate(workpackage, false).then(work_package => {
                    updateWBLObject({
                      path: [
                      {workpackage: ''}
                      ],
                      update: work_package
                      }),
                      $router.push({
                       name: `WorkBenchSequenceWaggonWorkPackageAddWorkPackageEditor`,
                       params: {
                         workpackage_id: 'create',
                       }
                     })
                    })
                  "
                  >
                  <v-icon small>file_copy</v-icon>
                </v-btn>
                </template>
                <span>{{$t('WorkBench.Editor.Sequence.Workpackage.copyWithoutSteps')}}</span>
              </v-tooltip>
          </template>
        </WorkBenchSequenceWaggonTab>
      </draggable>
      <WorkBenchSequenceWaggonTab
        v-if="!read_only"
        :color="`${$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3'} cursor-pointer`"
        :text_color="$vuetify.theme.isDark ? 'white' : 'black'"
        icon="sign-plus"
        :width="$route.matched[3].name === `${location}SequenceWaggonWorkPackageAdd`?`calc(100% - ${waggon[`${prefix}sworkpackages`].length-2} * 100px)`:'100px'"
        @click.native="
          $route.name !== `${location}SequenceWaggonWorkPackageAdd`?
          $router.push({
            name: `${location}SequenceWaggonWorkPackageAdd`
          }):''"
        >
        <template #content>
          <TText style="align-self: center;" value="add" />
        </template>
        <template
          #actions
          v-if="$route.matched[3].name === `${location}SequenceWaggonWorkPackageAdd`"
          >
          <StandardDataField
            icon="search"
            append_icon="clear"
            text_color="white"
            :one_liner="true"
            :value="getWBLObject({
              path: [
                {sequence_editor_variables: ''},
                {search: ''},
              ]
            })"
            @inputValue="
            updateWBLObject({
              path: [
                {sequence_editor_variables: ''},
              ],
              update: {
                search: $event
              }
            })"
            @clickAppendIcon="updateWBLObject({
              path: [
                {sequence_editor_variables: ''},
              ],
              update: {
                search: ''
              }
            })
            "
          />
        </template>
      </WorkBenchSequenceWaggonTab>
    </template>
  </WorkBenchSequenceWaggon>
</template>
<script>
  import { WorkBenchSequenceMixin } from '@/mixins/WorkBenchSequence.mixin.js'
  // import store from '@/store/index';
  export default {
    props: [
      'sequence_id',
      'waggon_id',
      'create',
      'read_only',
      'location',
    ],
    mixins: [
      WorkBenchSequenceMixin,
    ],
    data: () => ({
    }),
    created(){
    },
    methods: {
      routeToWaggonWorkPackage(index, workpackage){
        let newWorkpackageId;

        if(this.create === true){
          newWorkpackageId = index;
        }else{
          newWorkpackageId = workpackage.id;
        }

        if (newWorkpackageId !== this.$route.params.workpackage_id) {
          this.$router.push({
            name: `${this.location}SequenceWaggonWorkPackage`,
            params: { workpackage_id: newWorkpackageId }
          });
        }
      }
    },
    // beforeRouteUpdate: (to, from, next) => {
    //   if (to.params.sequence_id !== 'create') {
    //     let prefix = '';
    //     switch (to.params.template_type) {
    //       case 'custom':
    //         break;
    //       case 'company':
    //         prefix = 'b';
    //         break;
    //       case 'community':
    //         prefix = 'c';
    //         break;
    //     }
    //     store.dispatch('WorkBench/requestWBObject', {
    //       url: [
    //         {[`${prefix}sequences`]: to.params.sequence_id},
    //         {[`${prefix}swaggons`]: to.params.waggon_id},
    //         {[`${prefix}sworkpackages`]: to.params.workpackage_id},
    //         {showWithEntitiesNormalized: ''}
    //       ],
    //       template_type: to.params.template_type
    //     }).then(() => next())
    //   } else {
    //     next();
    //   }
    // }
  }
</script>
